import Leads from '../components/leads/Leads';
import LeadsCreate from '../components/leads/LeadsCreate';
import LeadsEdit from '../components/leads/LeadsEdit';

const Template = {
  template: '<router-view></router-view>',
};

export default {
  path: '/leads',
  component: Template,
  children: [
    {
      path: '',
      name: 'Leads',
      component: Leads,
      meta: {
        title: 'Leads - Mod24',
      },
    },
    {
      path: 'create',
      name: 'LeadsCreate',
      component: LeadsCreate,
      meta: {
        title: 'Create Lead - Mod24',
      },
    },
    {
      path: 'edit/:id',
      name: 'LeadsEdit',
      component: LeadsEdit,
      meta: {
        title: 'Edit Lead - Mod24',
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/leadsRoutes.js